/**
 * V2 ↔ V1 Address Adapter
 *
 * Transforms between V2 Address API shape and V1 DeliveryAddress shape
 * used by existing profile/display components.
 */

/**
 * V2 Address → V1 DeliveryAddress shape for display components.
 */
export function adaptV2AddressToV1(v2Address) {
  if (!v2Address) {
    return v2Address;
  }

  return {
    ...v2Address,
    address: v2Address.addressLine1,
    zipCode: v2Address.postalCode,
    isMainAddress: v2Address.isDefault,
  };
}

/**
 * V1 form data → V2 create/update body.
 * Explicitly picks only V2-allowed fields to avoid strictObject rejection.
 */
export function adaptV1AddressToV2CreateInput(v1Data, countryCode) {
  if (!v1Data) {
    return v1Data;
  }

  const result = {
    addressLine1: v1Data.address,
    postalCode: v1Data.zipCode,
    firstName: v1Data.firstName,
    lastName: v1Data.lastName,
    phone: v1Data.phone,
    latitude: v1Data.latitude,
    longitude: v1Data.longitude,
    apartment: v1Data.apartment,
    entrance: v1Data.entrance,
    floor: v1Data.floor,
    intercom: v1Data.intercom,
    region: v1Data.region,
    note: v1Data.note,
    city: v1Data.city,
    addressLine2: v1Data.addressLine2,
    state: v1Data.state,
  };

  if (countryCode) {
    result.countryCode = countryCode;
  }

  // Remove undefined keys so they don't get sent as null
  Object.keys(result).forEach((key) => {
    if (result[key] === undefined) {
      delete result[key];
    }
  });

  return result;
}
